import * as Yup from 'yup';

import { IBooking } from '@/pages/JMS/Managament/types/booking';

export const notesSchema = Yup.object<Pick<IBooking, 'housing'>>().shape({
  description: Yup.string()
    .max(500, 'Description should be less than 500 characters.')
    .required('This field is required'),
  officer: Yup.string().required('This field is required'),
});
